<div class="lmo-frac-fcpo-manage-pos">
  <mat-form-field class="search-form">
    <input matInput autocomplete="off" [formControl]="searchForm" placeholder="Search By Purchase Order Name" />
  </mat-form-field>
  <ng-container *ngIf="filteredPos$ | async as meshesWithPos">
    <ng-container *ngIf="meshesWithPos.length">
      <ng-container *ngFor="let mesh of meshesWithPos">
        <div class="mesh-header">{{ mesh.type }}</div>
        <div *ngFor="let po of mesh.pos" class="list-item">
          <ng-container *ngIf="!po.closed">
            <div class="text">
              <div>Name: {{ po.name }}</div>
              <div>Mine: {{ po.mineName }}</div>
              <div>
                <span *ngIf="po.maximumDailyAllocation"
                  >Daily Max: {{ po.maximumDailyAllocation / 2000 | number }} tons
                </span>
                <span *ngIf="po.maximumDailyAllocation && po.minimumDailyAllocation">| </span>
                <span *ngIf="po.minimumDailyAllocation"
                  >Daily Min: {{ po.minimumDailyAllocation / 2000 | number }} tons</span
                >
              </div>
              <div>{{ po.costPerTon / 100 | currency }} Cost / Ton</div>
              <div>Created On {{ po.createdTimestamp | date }}</div>
            </div>
            <div class="actions">
              <sa-network-active-button>
                <button mat-button color="warn" (click)="confirmClosePO(po.id)">Close</button>
              </sa-network-active-button>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #confirmClose>
  <h1 mat-dialog-title>Close Purchase Order</h1>
  <div mat-dialog-content>
    <p>Are you sure you want to close this purchase order?</p>
  </div>
  <div mat-dialog-actions class="actions">
    <button mat-button [mat-dialog-close]="false" color="primary">Cancel</button>
    <button mat-button [mat-dialog-close]="true" color="warn">Close</button>
  </div>
</ng-template>
